import type { ChildAgentRunMetadata } from '../../../contracts/harness.types';
import { readRecord } from '../metadata-readers';

/**
 * BE exposes child-run attach metadata under provider_metadata.data for both:
 * - live parent LLM events (`tool_execution_start.metadata.data`)
 * - persisted parent results (`tool_result.provider_metadata.data`)
 *
 * Keep snake_case at the boundary and return the camelCase shape used by the
 * harness timeline. Do not add speculative flat fallbacks here.
 */
export const readChildAgentRunMetadata = (
  metadata: Record<string, unknown> | undefined
): ChildAgentRunMetadata | null => {
  const data = readRecord(metadata?.data);
  const childAgentRunId = data ? readNonEmptyString(data.child_agent_run_id) : null;
  if (!childAgentRunId || !data) return null;

  const childAgentName = readNonEmptyString(data.child_agent_name);
  const kind = readNonEmptyString(data.kind);
  const targetId = readNonEmptyString(data.target_id);
  const childTurnId = typeof data.child_turn_id === 'string' ? data.child_turn_id : null;

  return {
    childAgentRunId,
    ...(childAgentName && { childAgentName }),
    ...(kind && { kind }),
    ...(targetId && { targetId }),
    childTurnId,
    persistent: data.persistent === true,
  };
};

const readNonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() ? value : null;
